import React, { useContext, useState } from "react"
// import FacebookLogo from "../../images/facebook-logo.png"
import GoogleLogo from "../../images/google-logo.png"
// import SMACLogo from "../../images/smac-logo.png"
import { OtherLoginMethodLogo, OtherLoginMethodLabel, LogoBox } from "./loginStyles"
import {
  Button,
  theme,
  FlexColumn,
  HorizontalSpacer,
} from "@omnichannel/ace-b2b-elements"
import {
  LOGIN_FACEBOOK_API_ENDPOINT,
  LOGIN_GOOGLE_API_ENDPOINT,
  LOGIN_APPLE_API_ENDPOINT,
  HOMEPAGE_WEB_BASE_URL,
  APP_ID,
} from "../../helpers/constants"
// import UrlParamsContext from "../../context/UrlParamsContext"
import styled from "styled-components"
import { Facebook } from "@styled-icons/boxicons-logos/Facebook"
import { Apple } from "@styled-icons/boxicons-logos/Apple"

const GoogleIcon = styled.img`
  width: 2.5rem;
`
const FacebookIcon = styled(Facebook)`
  width: 2.8rem;
`

const AppleIcon = styled(Apple)`
  width: 2.4rem;
`

const OtherLoginMethodButton = ({
  type,
  logo,
  label,
  onClick,
  disabled,
  bgColor = "#f8f8f8",
  borderColor = bgColor,
  textColor = "#fff",
  isLoggingInTo = "FACEBOOK",
}) => (
    <Button
      justifyContent={"space-between"}
      padding={"0rem 0 0 0"}
      width="100%"
      borderColor={borderColor}
      color={bgColor}
      fontSize={"1.4rem"}
      textColor={textColor}
      height="4.4rem"
      borderRadius=".2rem"
      leftIcon={logo && label && <LogoBox><OtherLoginMethodLogo>{logo}</OtherLoginMethodLogo></LogoBox>}
      onClick={() => onClick && onClick()}
      disabled={disabled}
      disabledColor={bgColor}
      alignItems={'center'}
    >
      {label && <OtherLoginMethodLabel flex={1}
        disabled={type === isLoggingInTo}
        type={type}
      >{label}</OtherLoginMethodLabel>}
      {!label && logo && <OtherLoginMethodLogo></OtherLoginMethodLogo>}
    </Button>
  )

const FacebookLoginButton = ({
  redirectUrl = HOMEPAGE_WEB_BASE_URL,
  appId = APP_ID,
  disabled,
  onFacebookLogin,
  isLoggingIn,
  label
}) => {
  const onClick = () => {
    if (onFacebookLogin) {
      onFacebookLogin()
    }

    window.location.replace(
      `${LOGIN_FACEBOOK_API_ENDPOINT}?redirectUrl=${redirectUrl}&appId=${appId}`
    )
  }

  return (
    <OtherLoginMethodButton
      disabled={disabled}
      logo={<FacebookIcon />}
      label={isLoggingIn ? " Please wait..." : label + "Facebook"}
      type="FACEBOOK"
      onClick={onClick}
      bgColor={"#4267b2"}
      isLoggingInTo={isLoggingIn ? "FACEBOOK" : ""}
    />
  )
}

const GoogleLoginButton = ({
  redirectUrl = HOMEPAGE_WEB_BASE_URL,
  appId = APP_ID,
  disabled,
  onGoogleLogin,
  isLoggingIn,
  label
}) => {
  const onClick = () => {
    if (onGoogleLogin) {
      onGoogleLogin()
    }

    window.location.replace(
      `${LOGIN_GOOGLE_API_ENDPOINT}?redirectUrl=${redirectUrl}&appId=${appId}`
    )
  }

  return (
    <OtherLoginMethodButton
      disabled={disabled}
      logo={<GoogleIcon src={GoogleLogo} />}
      label={isLoggingIn ? "Please wait..." : label + "Google"}
      onClick={onClick}
      borderColor={"#bbb"}
      // bgColor={"#4185F4"}
      textColor={"#333"}
      bgColor={"#fff"}
      type="GOOGLE"
      isLoggingInTo={isLoggingIn ? "GOOGLE" : ""}
    />
  )
}

const AppleLoginButton = ({
  redirectUrl = HOMEPAGE_WEB_BASE_URL,
  appId = APP_ID,
  disabled,
  onAppleLogin,
  isLoggingIn,
  label
}) => {
  const onClick = () => {
    if (onAppleLogin) {
      onAppleLogin()
    }

    window.location.replace(
      `${LOGIN_APPLE_API_ENDPOINT}?redirectUrl=${redirectUrl}&appId=${appId}`
    )
  }

  return (
    <OtherLoginMethodButton
      disabled={disabled}
      logo={<AppleIcon />}
      label={isLoggingIn ? "Please wait..." : label + "Apple"}
      onClick={onClick}
      // bgColor={"#4185F4"}
      bgColor={"#000"}
      type="APPLE"
      isLoggingInTo={isLoggingIn ? "APPLE" : ""}
    />
  )
}

const OtherLoginMethods = props => {
  const { isSignup } = props
  const [isLoggingInToFB, setIsLoggingInToFB] = useState(false)
  const [isLoggingInToGoogle, setIsLoggingInToGoogle] = useState(false)
  const [isLoggingInToApple, setIsLoggingInToApple] = useState(false)
  const urlParams = {}//useContext(UrlParamsContext)
  const isLoggingIn = isLoggingInToFB || isLoggingInToGoogle || isLoggingInToApple
  return (
    <FlexColumn justifyContent="space-between" padding="0 4.4rem">
      <FacebookLoginButton
        label={isSignup ? 'Sign up with ' : 'Sign in with '}
        isLoggingIn={isLoggingInToFB}
        disabled={props.disabled || isLoggingIn}
        redirectUrl={urlParams.redirectUrl}
        appId={urlParams.appId}
        onFacebookLogin={() => {
          setIsLoggingInToFB(true)
          props.onFacebookLogin()
        }}
      />
      <HorizontalSpacer height="1.6rem" />
      <GoogleLoginButton
        label={isSignup ? 'Sign up with ' : 'Sign in with '}
        disabled={props.disabled || isLoggingIn}
        redirectUrl={urlParams.redirectUrl}
        appId={urlParams.appId}
        isLoggingIn={isLoggingInToGoogle}
        onGoogleLogin={() => {
          setIsLoggingInToGoogle(true)
          props.onGoogleLogin()
        }}
      />
      <HorizontalSpacer height="1.6rem" />
      <AppleLoginButton
        label={isSignup ? 'Sign up with ' : 'Sign in with '}
        disabled={props.disabled || isLoggingIn}
        redirectUrl={urlParams.redirectUrl}
        appId={urlParams.appId}
        isLoggingIn={isLoggingInToApple}
        onAppleLogin={() => {
          setIsLoggingInToApple(true)
          props.onAppleLogin()
        }}
      />
      <HorizontalSpacer height="1.2rem" />
    </FlexColumn>
  )
}

export {
  FacebookLoginButton,
  GoogleLoginButton,
}

export default OtherLoginMethods
